import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  inputLabel?: string
}

const CommunicationsPreferences = ({ inputLabel, ...rest }: Props) => {
  const label = inputLabel || `Communications Preferences`

  return (
    <div className="mb-4 md:mb-2" data-gt-name="componentevent">
      <div>
        <h3 className={`text-l md:text-xl lg:text-2xl mb-3 !leading-snug`}>
          {label}
        </h3>
        <p className="text-tiny mb-4">
          Please select your communications options:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="col-span-1">
            <div className="mb-4">
              <p className="">Reminders </p>
              <p className="text-tiny leading-snug">
                By selecting &quot;Yes&quot; we will remind you at any time
                during your agreement of any offers or quotes that are due to
                expire. This way you won&lsquo;t forget.
              </p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="communication_reminders"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="communication_reminders"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="mb-4">
              <p className=""> Relevant Offers</p>
              <p className="text-tiny leading-snug">
                By selecting &quot;Yes&quot; we will send you communications and
                offers about our products and services. This may include
                upgrades to your vehicle and new product launches. This way you
                will never miss out.
              </p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="communication_relevantoffers"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="communication_relevantoffers"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className=" mb-4">
              <p className=""> Surveys</p>
              <p className="text-tiny leading-snug">
                From time to time we may send you surveys to help us develop and
                improve the financial services and products we offer to you and
                other customers. By selecting &quot;Yes&quot; we will contact
                you to have your say.
              </p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="communication_surveys"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="communication_surveys"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="mb-4">
              <p className=""> Events</p>
              <p className="text-tiny leading-snug">
                Occasionally we organise motoring related events, let us know if
                you&lsquo;d like to be there. By selecting &quot;Yes&quot; we
                will contact you about attending. This way you&lsquo;ll be on
                the guest list.
              </p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="communication_events"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="communication_events"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommunicationsPreferences
